import { useEffect } from 'react'
import { ProjectWrapper, LinkButton } from '../../GlobalStyles'
import { ViewAllProjects } from '../../components/ViewAllProjects'
import { Carousel } from '../../components/Carousel'
import wave from '../../assets/white-wave.svg'

import image1 from '../../assets/plantgeek-app/plantgeek-app1.png'
import image2 from '../../assets/plantgeek-app/plantgeek-app2.png'
import image3 from '../../assets/plantgeek-app/plantgeek-app3.png'
import image4 from '../../assets/plantgeek-app/plantgeek-app4.png'
import image5 from '../../assets/plantgeek-app/plantgeek-app5.png'
import image6 from '../../assets/plantgeek-app/plantgeek-app6.png'

export const PlantgeekApp = () => {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const projectImages = [image1, image2, image3, image4, image5, image6]

  return (
    <ProjectWrapper>
      <div
        className='banner'
        style={{ background: 'linear-gradient(to right, #A4E17D, #95D190)' }}
      >
        <img src={wave} alt='decorative wave' />
      </div>

      <section className='description'>
        <h1 className='title'>[ <b>Plantgeek App</b> ]</h1>
        <div className='summary'>
          <p className='type'>Full Stack Development, Mobile App</p>
          <p className='duration'>Solo Project • Jan – Feb 2023</p>
        </div>

        <div className='details'>
          <p>
            Plantgeek App extends the Plantgeek web platform into a native mobile experience.  
            Built with React Native and Expo, it lets users explore plant varieties, add to collections,  
            and track care routines on the go.
          </p>
        </div>

        <div style={{ margin: '40px 0' }}>
          <Carousel images={projectImages} />
        </div>

        <div className='details'>
          <p>
            This app mirrors core web flows—browsing, wishlisting, and care scheduling—while leveraging  
            device-specific features like haptic feedback and local notifications for watering reminders.
          </p>
        </div>

        <div style={{ margin: '40px 0' }}>
          <iframe
            className='video'
            src='https://www.youtube.com/embed/8eRWThYmcSQ'
            title='Plantgeek App Demo'
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
            allowFullScreen
          />
        </div>

        <div className='details'>
          <p>
            Engineered for performance and usability: offline caching for plant data, intuitive UI layouts,  
            and seamless navigation ensure users manage their green spaces effortlessly.
          </p>
          <p>
            <b>Tech stack:</b> React Native · Expo · React Query · TypeScript · Node.js · Express · MongoDB
          </p>
          <div className='buttons'>
            <LinkButton
              className='black'
              href='https://github.com/v-prt/plantgeek-app'
              target='_blank'
              rel='noopener noreferrer'
            >
              View on GitHub
            </LinkButton>
          </div>
        </div>
      </section>
      <ViewAllProjects />
    </ProjectWrapper>
  )
}
